import React, { useEffect, useState } from 'react';
const EventimeHero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Hero carousel images - Updated V3 branding images
  const heroImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_glassmorph-eventime/artifacts/el97a604_Home%201%20V3.png",
      alt: "Community Event Sports"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_glassmorph-eventime/artifacts/2ym3b8tf_Home%202%20V3.png", 
      alt: "Virtual E-Sport & Sports Mix"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_glassmorph-eventime/artifacts/ct09dkto_Home%20V3.png",
      alt: "Eventime Branding"
    }
  ];

  // No animations - pure slideshow only

  // Carousel auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  // Pure slideshow - no manual controls or scroll handlers

  return (
    <section id="hero" className="section-hero">
      {/* Carousel Background Images */}
      <div className="hero-carousel">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentImageIndex ? 'active' : ''}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: index === currentImageIndex ? 1 : 0,
              // No transition effects
              zIndex: 1
            }}
          >
            <img 
              src={image.url}
              alt={image.alt}
              className="hero-bg"
              loading="eager"
              style={{
                // No transform effects
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                // No effects - pure original banner colors only
              }}
            />
          </div>
        ))}
        
        {/* Completely removed - no overlay at all */}
      </div>
      
      <div className="container">
        {/* Pure Image Carousel - No Static Elements */}
      </div>
    </section>
  );
};

export default EventimeHero;